const DEFAULT_URL = '';

export const getBaseURL = () => {
    return localStorage.getItem('baseURL') || DEFAULT_URL;
};

const baseURL = getBaseURL();

export default baseURL;
